import { t } from "@redotech/redo-i18n";
import {
  ClaimSystemView,
  NEEDS_ATTENTION_FOLDER_NAME,
  RecycleSystemView,
  WarrantySystemView,
  WithdrawalSystemView,
} from "@redotech/redo-return-operations-common/views/default-return-views";
import {
  getReturnListSystemViewLabel,
  isReturnListSystemViewIdentity,
} from "../../../../return/returns-list-labels";

export function getReturnOperationsNavViewLabel(viewName: string): string {
  if (isReturnListSystemViewIdentity(viewName)) {
    return getReturnListSystemViewLabel(viewName);
  }

  switch (viewName) {
    case ClaimSystemView.ALL_CLAIMS:
      return t("All claims");
    case ClaimSystemView.MERCHANT_REVIEW:
      return t("Merchant review");
    case ClaimSystemView.MANAGED:
      return t("Managed");
    case WarrantySystemView.ALL_WARRANTIES:
      return t("All warranties");
    case WarrantySystemView.REPAIRS:
      return t("Repairs");
    case RecycleSystemView.ALL_RECYCLE:
      return t("All recycle", {
        context: "nav view listing every item sent for recycling",
      });
    case WithdrawalSystemView.ALL_WITHDRAWALS:
      return t("All withdrawals");
    default:
      return viewName;
  }
}

export function getReturnOperationsNavFolderLabel(folderName: string): string {
  if (folderName === NEEDS_ATTENTION_FOLDER_NAME) {
    return t("Needs attention");
  }
  return folderName;
}
